import React from 'react';
import PriceListGroups from '../../containers/PriceListGroups/PriceListGroups';

const PriceListGroupsPage = () => {
  return <PriceListGroups />;
};

export default PriceListGroupsPage;
